import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import CMSGallery from "../components/CMSGallery";
import { COMPANY, IMAGES, OM_MIG_TEXT } from "../data/content";

function formatFormattedText(text) {
  const regex = /(Mangalarga Marchador|Natural Horse Care Practitioner|ISNHCP)/g;
  const parts = text.split(regex);
  return parts.map((part, i) => {
    if (part === "Mangalarga Marchador" || part === "Natural Horse Care Practitioner" || part === "ISNHCP") {
      return <strong key={i} className="font-bold">{part}</strong>;
    }
    return part;
  });
}

export default function OmMig() {
  return (
    <>
      <SEO
        title="Om Metteline Hjorth"
        description="Mød Metteline Hjorth – certificeret Natural Horse Care Practitioner, instruktør for ISNHCP og indehaver af Hoofcare. Læs om min baggrund og mit syn på naturlig hovtrimning."
      />

      {/* Header Banner */}
      <section className="bg-forest-900 text-white py-14 lg:py-18">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-3">
          <span className="text-xs font-bold uppercase tracking-wider text-emerald-400">
            Hvem står bag Hoofcare?
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-sand-50">
            Om Mig
          </h1>
          <p className="text-sand-200 max-w-2xl text-base leading-relaxed">
            Metteline Hjorth – Certificeret Natural Horse Care Practitioner i Jylland.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-sand-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            {/* Large Portrait Image */}
            <div className="lg:col-span-5">
              <div className="relative rounded-2xl overflow-hidden border border-sand-300 shadow-md">
                <img
                  src={IMAGES.portrait.replace("assets.auxodev.dk/", "assets.auxodev.dk/cdn-cgi/image/width=1000,format=auto,quality=85/")}
                  alt="Metteline Hjorth - Hoofcare hovtrimmer"
                  className="w-full h-auto object-cover min-h-[380px]"
                />
                <div className="p-4 bg-forest-900 text-white text-xs space-y-1">
                  <p className="font-bold text-sand-50">Metteline Hjorth - {COMPANY.name}</p>
                  <p className="text-sand-200">Fabjergvej 142, 7620 Lemvig</p>
                </div>
              </div>
            </div>

            {/* Bio Text */}
            <div className="lg:col-span-7 space-y-5">
              <span className="text-xs font-bold uppercase tracking-wider text-earth-700">
                Om mig
              </span>
              <h2 className="text-2xl sm:text-3xl font-bold text-forest-900 tracking-tight leading-snug">
                {OM_MIG_TEXT.title}
              </h2>

              {OM_MIG_TEXT.paragraphs.map((paragraph, index) => (
                <p
                  key={index}
                  className={`text-charcoal-700 leading-relaxed text-base ${
                    index === OM_MIG_TEXT.paragraphs.length - 1 ? 'font-bold' : ''
                  }`}
                >
                  {formatFormattedText(paragraph)}
                </p>
              ))}

              <div className="pt-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="p-4 bg-white rounded-xl border border-sand-200 shadow-2xs space-y-1">
                  <div className="text-forest-800 font-bold text-sm flex items-center gap-2">
                    <i className="fa-solid fa-certificate text-emerald-600"></i> Certificering i 2021
                  </div>
                  <p className="text-xs text-charcoal-600">Natural Horse Care Practitioner certificering d. 19 marts 2021.</p>
                </div>

                <div className="p-4 bg-white rounded-xl border border-sand-200 shadow-2xs space-y-1">
                  <div className="text-forest-800 font-bold text-sm flex items-center gap-2">
                    <i className="fa-solid fa-heart text-emerald-600"></i> Egen vandrefold
                  </div>
                  <p className="text-xs text-charcoal-600">Erfaring fra eget naturlige hestehold og løsdrift.</p>
                </div>
              </div>
            </div>
          </div>

          {/* CMS Galleri */}
          <div className="pt-6 border-t border-sand-300">
            <CMSGallery gallerySlug="om-mig" title="Galleri: Fra hverdagen med hestene" />
          </div>

          {/* Contact Box */}
          <div className="text-center pt-4">
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-forest-900 hover:bg-forest-800 text-white font-bold text-sm transition-colors shadow-sm cursor-pointer"
            >
              <i className="fa-solid fa-calendar-plus text-emerald-400"></i>
              <span>Book besøg til din hest</span>
            </Link>
          </div>

        </div>
      </section>
    </>
  );
}
